import {Module} from '@dms/api/shared';
import {moduleKeys} from '@dms/config';
import {featureFlags} from '@dms/feature-flags';
import {auctionRoutes} from '@dms/routes';
import {permissions} from '@dms/shared';

import {AuctionList} from './pages/AuctionList/AuctionList';

export const AuctionModule: Module = {
  id: moduleKeys.auction,
  layoutProps: {
    title: 'entity.auction.labels.auction',
    icon: 'action/gavel',
  },
  routerProps: {
    path: auctionRoutes.overview,
    element: <AuctionList />,
  },
  requiredPermission: permissions.vehicleRead,
  requiredFeatureFlag: featureFlags.AUCTIONS,
  content: [
    {
      id: 'auction.overview',
      routerProps: {
        path: auctionRoutes.overview,
        element: <AuctionList />,
      },
      layoutProps: {
        title: 'entity.auction.labels.auction',
        icon: 'action/gavel',
      },
    },
  ],
};
